import styled from "styled-components/macro"

export const Footer = styled.div`
  background-color: rgb(21, 21, 21);
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height : auto;
  color: white;
  text-align: center;
`
